import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";
import { FeatureImageCfLeft } from "../../sections/FeatureImageCfLeft";

const ghibli_filter_faq_data = [
    {
        question: "What is the AI Ghibli filter?",
        answer: "The AI Ghibli filter is a tool that transforms your photos into art inspired by Ghibli's animation style. It uses advanced artificial intelligence to recreate the soft, whimsical, and magical feel of Ghibli movies. You'll love the dreamlike quality of the final images, which have a unique and enchanting look.",
    },
    {
        question: "Who can benefit from the AI Ghibli filter?",
        answer: "Anyone can use the AI Ghibli filter to add a touch of artistry to their photos. For example, graphic designers can create concept art or storybook illustrations easily. Digital marketers can incorporate this style into campaigns to stand out and captivate their audience. Game developers can design imaginative Ghibli-style assets, like backgrounds or characters. Social media creators can grab users' attention and attract likes and shares. Hobbyists can turn everyday photos into artistic keepsakes or gifts.",
    },
    {
        question: "How to use the AI Ghibli filter?",
        answer: "It's easy! Just upload your photo, and let Patternful.ai transform it in seconds. You can also use the filter to create custom art pieces, storyboards, or digital designs. Our AI filter preserves details while adding dreamy textures and soft hues that evoke classic Ghibli animations. Plus, it's quick, intuitive, and endlessly creative!",
    },
    {
        question: "What about privacy? Are my photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

const ghibli_filter_use_cases = [
    {
        title: "Storybook Illustrations",
        description:
            "If you're a designer working on illustrations, the Ghibli filter transforms your sketches and adds studio-quality touches to your images. Your characters and scenes will come to life with a soft, whimsical touch, resonating with readers of all ages.",
        image: "/images/image-filters/ghibli-filter-5.webp",
    },
    {
        title: "Marketing Campaigns",
        description:
            "Add a touch of magic to your promotional materials and turn your banners, logos, and graphics into Ghibli-style art. The stunning visuals will introduce an emotional and nostalgic element, helping your brand stand out and capture viewers' attention.",
        image: "/images/image-filters/ghibli-filter-6.webp",
    },
    {
        title: "Game Art",
        description:
            "Elevate your game design assets, like backgrounds, character portraits, and in-game art, with a Ghibli filter. The rich, artistic, whimsical aesthetics will captivate players and transport them to a beautiful, fantastical world.",
        image: "/images/image-filters/ghibli-filter-7.webp",
    },
];

const GhibliFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/ghibli-filter-2.webp"}
                title={"Turn Your Portraits into Ghibli-Style Art"}
                description={
                    "Add a touch of Ghibli magic to your portraits. You can turn your selfies, family photos, and snapshots of loved ones into captivating art pieces. Our Ghibli filter enhances facial details, softens tones, and infuses your images with whimsy and nostalgia. You'll love the hand-drawn quality of the final version inspired by iconic Ghibli characters. The effect is excellent if you want to create unique profile pictures, special gifts, or explore your creative side. Try it today and see your portraits reimagined in a stunning Ghibli art style!"
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/ghibli-filter-1.webp"}
                title={"Give Your Pets and Landscape Photos a Ghibli Glow"}
                description={
                    "Bring your outdoor photos to life with our enchanting Ghibli filter. From peaceful hillsides and shimmering lakes to golden sunsets and colorful cityscapes, this filter turns everyday scenes into whimsical, storybook worlds. It enhances each detail with soft textures, vivid tones, and the signature Ghibli magic—creating illustrations that feel lifted straight from an anime film. Perfect for travel memories, unique wall art, or sparking your imagination. Simply upload your photo and watch your landscape transform into a dreamy animated masterpiece."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/ghibli-filter-3.webp"}
                title={"Create Stunning Ghibli-Inspired Illustrations"}
                description={
                    "If you're working on a creative project or experimenting with artistic transformations, our Ghibli filter offers the perfect blend of whimsy and precision. Designed for artists, hobbyists, and fans alike, it creates dreamy, Ghibli-style art for everyone. It's perfect for generating custom art pieces, storyboards, or digital designs. Our AI filter preserves details while adding dreamy textures and soft hues that evoke classic Ghibli animations. Plus, it's quick, intuitive, and endlessly creative!"
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/ghibli-filter-4.webp"}
                title={
                    "Wow Your Followers by Sharing Ghibli-Style Photos on Social Media"
                }
                description={
                    "Want to impress your followers? Share Ghibli-style creations on Instagram, Facebook, or TikTok. You can post dreamy landscapes, whimsical portraits, or artistic illustrations. The Ghibli filter's aesthetic will make your photos stand out, sparking conversations and admiration from your audience. Just upload your photo, select the Ghibli filter, and let AI transform it in seconds. Whether you're sharing them for personal enjoyment or promoting your brand, the charming Ghibli-style photos will leave a lasting impression. Make every post a masterpiece!"
                }
            />
            <UseCases
                data={ghibli_filter_use_cases}
                title={"Creative and Pretty Ghibli Filters for Everyone"}
            />
            <SellFaq data={ghibli_filter_faq_data} />
        </PBox>
    );
};

export default GhibliFilter;
